var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},_vm._l((_vm.mappedActiveFilters),function(filter){return _c('ActiveFilterItem',{key:filter.value,attrs:{"label":filter.label,"value":filter.value},on:{"click":function($event){return _vm.$emit('click', filter)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }